


















































































import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { GEnum } from '@/constants/enum.defination';
import { Component } from 'vue-property-decorator';
import { Teacher } from '@/models/teacher/teacher';
import { BreadCrumbElement } from '@/models/bread-crumb-element';
import { SchoolClass } from '@/models/school-class/school-class';
import { teacherModule } from '@/store/modules/entities/teacher.module';
import { TeacherSearch } from '@/models/teacher/teacher-search';
import GCustomBreadCrumb from '@/components/GCustomBreadCrumb.vue';
import GTitleBar from '@/components/GTitleBar.vue';
import GTeachersImport from '@/views/GTeachers/GTeachersImport.vue';
import { globalModule } from '@/store/modules/global.module';

@Component({
  name: 'GTeachers',
  components: {
    GTeachersImport,
    GTitleBar,
    GCustomBreadCrumb,
  },
  methods: {},
})
export default class GTeachers extends mixins(GPageBase) {
  breadCrumbItems: BreadCrumbElement[] = [];
  breadCrumbItemHome: BreadCrumbElement = null;
  facultyListColumn: object[] = [];
  countPerPage: number = 15;
  keyword: string = '';
  teachersSortOrder: string = 'asc';
  teachersSortKey: number = 1;
  currentPage: number = 1;
  showTeacherImportModal: boolean = false;
  hasInvalid: GEnum.RadioLabel = GEnum.RadioLabel.False;

  async mounted() {
    if (this.isOldSchoolYear) {
      this.breadCrumbItemHome = { title: this.$t('HOME').toString(), icon: 'ios-home' }; //リンクなし
    } else {
      this.breadCrumbItemHome = { title: this.$t('HOME').toString(), icon: 'ios-home', routerPath: '/pages/home' };
    }
    this.breadCrumbItems = [this.breadCrumbItemHome, { title: this.$t('SETTING_AND_MANAGEMENT').toString() }, { title: this.$t('TEACHER_MANAGEMENT').toString() }];
    this.createColumn();
    teacherModule.fetchTeacherList({} as TeacherSearch);
  }

  get isRoleNormal(): boolean {
    return this.$store.state.account.isRoleNormal;
  }

  get isOldSchoolYear() {
    return globalModule.isOldSchoolYear;
  }

  get teachersByPage() {
    return this.teachers.slice(this.offset, this.offset + this.countPerPage);
  }

  get teachers() {
    let tempTeachers: Teacher[] = [];
    if (this.hasInvalid === GEnum.RadioLabel.True) {
      tempTeachers = teacherModule.teachers;
    } else {
      tempTeachers = teacherModule.validTeachers;
    }
    return tempTeachers.filter((teacher: Teacher) => {
      if (this.keyword === '') {
        return true;
      }
      return teacher.fullName.indexOf(this.keyword) > -1 || teacher.fullNameByLang.indexOf(this.keyword) > -1;
    });
  }

  createColumn() {
    this.facultyListColumn = [this.columnFullName, this.columnEmail, this.columnAssignedSchoolClasses, this.columnAuthority, this.action];
  }

  get offset(): number {
    return (this.currentPage - 1) * this.countPerPage;
  }

  get columnFullName() {
    return {
      title: this.$t('FULL_NAME').toString(),
      key: 'fullNameByLang',
      sortable: 'custom',
      align: 'center',
    };
  }

  get columnEmail() {
    return {
      title: this.$t('EMAIL').toString(),
      key: 'email',
      sortable: 'custom',
      align: 'center',
    };
  }

  get columnAssignedSchoolClasses() {
    return {
      title: this.$t('CLASS_IN_CHARGE').toString(),
      key: 'grade_and_school_class_name',
      align: 'center',
      render: (h: any, params: any) => {
        const teacher: Teacher = this.teachersByPage[params.index];
        return h(
          'Tooltip',
          {
            props: {
              content: teacher.schoolClasses.map((schoolClass: SchoolClass) => schoolClass.schoolClassNameWithGrade).join(' | '),
              placement: 'top',
              transfer: true,
              'max-width': 200,
            },
          },
          this.showGradeAndSchoolClassName(teacher.schoolClasses)
        );
      },
    };
  }

  get columnAuthority() {
    return {
      title: this.$t('AUTHORITY').toString(),
      key: 'role',
      align: 'center',
      render: (h: any, params: any) => {
        const teacher: Teacher = this.teachersByPage[params.index];
        return h('div', this.showAuthority(teacher.role));
      },
    };
  }

  get action() {
    return {
      title: ' ',
      key: 'action',
      width: 150,
      align: 'center',
      render: (h: any, params: any) => {
        const teacher: Teacher = this.teachersByPage[params.index];
        return h('div', [
          h(
            'a',
            {
              props: {
                type: 'primary',
                size: 'small',
              },
              style: {
                marginRight: '5px',
              },
              on: {
                click: () => {
                  this.$router.push(`/pages/teacher-edit/${teacher.teacherID}`);
                },
              },
            },
            this.showEditLink(teacher.email)
          ),
        ]);
      },
    };
  }

  get isRoleIgsAdmin(): boolean {
    return this.$store.state.account.isRoleIgsAdmin;
  }

  showAuthority(role: GEnum.Role): string {
    if (role === GEnum.Role.Admin) {
      return this.$t('ADMIN').toString();
    } else if (role === GEnum.Role.Normal) {
      return this.$t('GENERAL').toString();
    } else {
      return '';
    }
  }

  showGradeAndSchoolClassName(schoolClasses: SchoolClass[]): string {
    let text: string;
    text = schoolClasses
      .slice(0, 5)
      .map((schoolClass: SchoolClass) => schoolClass.schoolClassNameWithGrade)
      .join(',');
    if (schoolClasses.length >= 5) {
      text += '...';
    }
    return text;
  }

  showEditLink(email: string): string {
    if (this.isRoleIgsAdmin || (!this.isOldSchoolYear && (this.$store.state.account.isRoleAdmin || email === this.$store.state.account.email))) {
      //管理者権限を持っているか、または、自分の編集画面である場合のみ表示
      return this.$t('TEACHER_EDIT_LINK').toString();
    } else {
      return '';
    }
  }

  handleHasInvalid() {
    this.currentPage = 1;
    // this.handlePagerChange(this.currentPage);
  }

  handleDownloadUpdateTeacher() {
    this.isRunning = true;
    teacherModule.downloadUpdateTeacher(this.convertRadioToBoolean(this.hasInvalid)).then(() => {
      this.isRunning = false;
    });
  }

  handleSort(event: any) {
    if (!event) {
      return;
    }
    this.teachersSortOrder = event.order;
    switch (event.key) {
      case 'fullName':
        this.teachersSortKey = 1;
        break;
      case 'email':
        this.teachersSortKey = 2;
        break;
      default:
        this.teachersSortKey = 1;
        break;
    }
    const teacherSortOptions = {
      sortKey: this.teachersSortKey,
      sortType: this.getSortType(),
    } as TeacherSearch;
    teacherModule.fetchTeacherList(teacherSortOptions);
  }

  handlePagerChange(pageNumber: number) {
    this.currentPage = pageNumber;
  }

  getSortType(): number {
    return this.teachersSortOrder == 'desc' ? -1 : 1;
  }

  rowDisableColor(row: Teacher): string {
    if (!row.isValid) {
      return 'invalid-row';
    } else if (row.schoolClasses.length === 0 && row.role === GEnum.Role.Normal) {
      return 'no-setting-row';
    }
  }
}
